import React from "react";
import { object, bool } from "prop-types";
import { Link } from "@quintype/components";

import StoryMetaData from "../../molecules/StoryMetaData";

import "./sectionHolder.m.css";

const SectionHolder = ({ sectionData, isMetaDataShown = true, story = {}, showSectionTag }) => {
  return (
    <div styleName="time">
      {showSectionTag && sectionData && (
        <span styleName="section-tag">
          {sectionData.link ? <Link href={sectionData.link}>{sectionData.name}</Link> : sectionData.name}
        </span>
      )}
      {isMetaDataShown ? <StoryMetaData story={story} /> : null}
    </div>
  );
};

SectionHolder.propTypes = {
  sectionData: object,
  isMetaDataShown: bool,
  story: object,
  showSectionTag: bool,
};

export default SectionHolder;
